import { apiAxiosCMS } from 'services/api';
import { AdmPainelComponentsProps } from 'types/AdmPainelComponentsProps';

interface RespGetComponents {
	isSuccess: boolean;
	data: AdmPainelComponentsProps[];
}

export async function getComponents(handleNotify: any) {
	const resp: RespGetComponents = { isSuccess: false, data: [] };
	await apiAxiosCMS
		.get('schemas?languageSlug=en')
		.then((res) => {
			resp.data = res.data;
			resp.isSuccess = true;
		})
		.catch((error) => {
			resp.data = [];
			resp.isSuccess = false;
			handleNotify(error?.message || 'Erro ao buscar os componentes', 'error');
		});

	return resp;
}

interface RespToggleComponent {
	isSuccess: boolean;
	data: AdmPainelComponentsProps | null;
}

export async function toggleComponent(
	item: AdmPainelComponentsProps,
	handleNotify: any
) {
	const resp: RespToggleComponent = { isSuccess: false, data: null };

	await apiAxiosCMS
		.patch(`schemas?id=${item.id}`, { active: !item.active })
		.then((res) => {
			resp.data = res.data;
			resp.isSuccess = true;
			handleNotify('Status do componente atualizado com sucesso!', 'success');
		})
		.catch((error) => {
			resp.data = null;
			resp.isSuccess = false;
			handleNotify(
				error?.message || 'Erro ao atualizar status do componente',
				'error'
			);
		});

	return resp;
}
